import { useRouter } from "next/router";
import { ImpactType } from "@ecologi/shared";

export function useImpactShopFilter(): {
  impactTypes: ImpactType[];
  toggleImpactType: (impactType: ImpactType) => void;
  clearImpactTypes: () => void;
  isUkOnly: boolean;
  setIsUkOnly: (isUkOnly: boolean) => void;
} {
  const router = useRouter();

  const impactTypes = parseImpactTypes(router.query.impactType);
  const ukOnly = router.query.ukOnly;
  const isUkOnly = ukOnly === "true";

  const updateQueryParams = (newImpactTypes: ImpactType[]) => {
    router.push(
      {
        pathname: router.pathname,
        query: newImpactTypes.length > 0 ? { impactType: newImpactTypes } : {},
      },
      undefined,
      { shallow: true }
    );
  };

  const toggleImpactType = (impactType: ImpactType) => {
    const newImpactTypes = impactTypes.includes(impactType)
      ? impactTypes.filter((t) => t !== impactType)
      : [...impactTypes, impactType];
    updateQueryParams(newImpactTypes);
  };

  const clearImpactTypes = () => {
    updateQueryParams([]);
  };

  const setIsUkOnly = (isUkOnly: boolean) => {
    router.push(
      {
        pathname: router.pathname,
        query: isUkOnly ? { ukOnly: "true" } : {},
      },
      undefined,
      { shallow: true }
    );
  };

  if (impactTypes.length > 0) {
    return {
      impactTypes,
      toggleImpactType,
      clearImpactTypes,
      isUkOnly: false,
      setIsUkOnly,
    };
  } else {
    return {
      impactTypes: [],
      toggleImpactType,
      clearImpactTypes,
      isUkOnly,
      setIsUkOnly,
    };
  }
}

function parseImpactTypes(value: string | string[] | undefined): ImpactType[] {
  if (!value) return [];

  const values = Array.isArray(value) ? value : [value];
  return values.filter(isImpactType);
}

function isImpactType(value: string): value is ImpactType {
  return Object.keys(ImpactType).includes(value);
}
